import { Modal } from 'antd';
import { useSelector } from 'react-redux';

import ServerErrorImageLight from '../../../assets/images_light/ServerError.png'
import ServerErrorImageDark from '../../../assets/images_dark/ServerError.png'

const ErrorBoundary = () => {
    const isVisible = useSelector(state => state.general.ifServerUnavailable)
    const theme = useSelector(state => state.general.theme)

    return (
        <Modal
            visible={isVisible}
            maskClosable={false}
            closable={false}
            footer={null}
            width={800}
            className="ErrorBoundary_modal">
            <div>
                <img width={200} src={theme === 'dark' ? ServerErrorImageDark : ServerErrorImageLight} alt="ServerErrorImage" />
            </div>
            <div className="ErrorBoundary_title">
                Сервер в данный момент недоступен. Попробуйте позже.
            </div>
        </Modal>
    )
}

export default ErrorBoundary;